import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import {
    Menu,
    message,
    Modal,
    Popconfirm,
    Select,
    Tabs,
    Tooltip,
    Upload
} from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

// Components
import moment from 'moment';
import { saveAs } from 'file-saver'
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { apiPOSTReq, getPreSignedS3Url, getJwt } from '../../../../Utils/api';
import environment from '../../../../environment';
import { Text } from '../../../Reusable/Text'
import TableView from '../../../Reusable/TableView';
import { LabeledInput } from '../../../Reusable/Input'
import { Paragraph, Tag } from '../../../Reusable/Text';
import { ErrorAlert } from '../../../Reusable/Alert';
import { Image } from '../../../Reusable/Image'
import { TextButton, Button, ImageButton } from '../../../Reusable/Button';
import UploadIcon from '../../../../Images/upload.svg'
import Edit from '../../../../Images/edit.png'

import AdditionalDocuments from './AdditionalDocuments';
import AdditionalDocs from './AdditionalDocs';
import Download from "../../../../Images/download.png"
import { Flex, FlexColumn, LineItemsHeader, LineItemRow, LightContainer } from '../../../Reusable/Container';

const { Option } = Select
class Index extends Component {

    state = {
        pagination: {
            current: 1,
            pageSize: 10000
        },
        businessDocuments: [],
        fileList: [],
        popupLoading: false,
        selectedTab: 'All',
        approvedRequests: []

    };

    componentDidMount() {
        this.fetchData({ pagination: this.state.pagination });
        this.fetchApprovedRequests({ pagination: this.state.pagination })
        this.fetchBusinessAttributes();
        getJwt((err, jwt) => {
            this.setState({ jwt });
        });
    }

    fetchData = (options) => {
        const { loanApp } = this.props;
        const { pagination } = options || {};
        var body = {
            "size": pagination.pageSize,
            "page": pagination.current - 1,
            "sortDirection": "DESC"
        };
        if (loanApp) {
            body["clientBusinessId"] = loanApp.businessId;
            body["applicationId"] = loanApp.applicationId;
            body["viewBy"] = "FILTER_APPLICATION_ID"
        }
        console.log("/docs/getActiveDocuments body", body);
        this.setState({ loading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/getActiveDocuments`, {}, body, (err, resp) => {
            console.log("/docs/getActiveDocuments resp", resp);
            this.setState({ loading: false });
            try {
                const data = resp || {};
                if (data.result) {

                    var businessDocuments = data.businessDocuments.filter(doc => doc.category != "Owner Financials");
                    this.setState({
                        businessDocuments: businessDocuments,
                        pagination: {
                            ...pagination,
                            total: data.count,
                            pageable: data.pageable
                        }
                    });

                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                //console.log("/getPersonCards err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    fetchBusinessAttributes = () => {
        var body = {
            "clientBusinessId": ''
        };

        apiPOSTReq(`${environment.opsBaseUrl}/ops/fetchBusinessAttributes`, null, body, (err, resp) => {
            try {
                if (err) throw Error(err);
                const data = resp || {};
                if (data.result) {
                    var categories = data.businessAttributes.filter(x => x.name == "FileUploadCategories");
                    var subCategories = data.businessAttributes.filter(x => x.name == "FileUploadSubCategories");
                    this.setState({
                        fileCategories: categories[0].additionalParameterReference.parameters,
                        fileSubCategories: subCategories[0].additionalParameterReference.parameters
                    });
                } else {
                    throw Error(data.responseMessage || data.error);
                }
            } catch (error) {
                console.log("/fetchBusinessAttributes err", error, resp);
            }
        });
    }

    handleMenuClick = (status, item) => {
        console.log("handleMenuClick", status, item);
        this.setState({ loading: true });
        var businessDocument = {
            ...item
        };
        businessDocument["status"] = status;
        var body = {
            "businessDocument": businessDocument
        }
        this.setState({ loading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/save`, {}, body, (err, resp) => {
            this.fetchData({ pagination: this.state.pagination });
            this.setState({ loading: false });
            try {
                const data = resp || {};
                if (data.result) {
                    message.success(`Status updated successfully.`, 0.75);
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/docs/save err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    getColumns = () => {
        const statusMenu = (item) => (
            <Menu onClick={(e) => this.handleMenuClick(e.key, item)}>
                <Menu.Item key="In Review">
                    In Review
                </Menu.Item>
                <Menu.Item key="Validated">
                    Validated
                </Menu.Item>
                <Menu.Item key="Additional Info Requested">
                    Additional Info Requested
                </Menu.Item>
            </Menu>
        )
        return [
            // {
            //     title: 'Id',
            //     width: 100,
            //     dataIndex: 'documentId'
            // },
            {
                title: 'Date',
                width: 100,
                dataIndex: 'auditData',
                render: item => moment(item.createTime).format('MM/DD/YY')
            },
            {
                title: 'Name',
                width: 350,
                render: (item) => <Paragraph size="0.95rem" bold noMargin>{item.name === "External Bank Statement" || item.name === "FinancialReport" || item.name === "ControlCenter" ? item.displayName : item.name}
                    {
                        item.errorMessage &&
                        <Tooltip title={item.errorMessage}>
                            <ExclamationCircleFilled style={{ color: 'orange' }} />
                        </Tooltip>
                    }
                    {
                        item.subType && item.subType == "BusinessFinancials" && <Tag primary>{
                            item.source == 'System' ? 'QuickBooks' : 'Manual Upload'
                        }</Tag>
                    }
                </Paragraph>
            },
            // {
            //     title: 'Period',
            //     width: 100,
            //     render: (record) => record.effectiveStartDate ? `${moment(record.effectiveStartDate).format('MM/DD/YY')} to ${moment(record.effectiveEndDate).format('MM/DD/YY')}` : "--"
            // },
            {
                title: 'Category',
                width: 150,
                dataIndex: 'category'
            },
            {
                title: 'Sub Category',
                width: 150,
                dataIndex: 'subCategory'
            },
            {
                title: 'Uploaded By',
                width: 150,
                dataIndex: 'auditData',
                render: item => item.createdBy ? item.createdBy : "System"
            },
            {
                title: 'Updated By',
                width: 150,
                dataIndex: 'auditData',
                render: item => item.lastModifiedBy && item.lastModifiedBy
            },
            // {
            //     title: 'Closing Date',
            //     width: 130,
            //     dataIndex: 'closingDate'
            // },
            // {
            //     title: 'Status',
            //     dataIndex: 'status',
            //     width: 100,
            //     render: (status, item) => (
            //         <Dropdown overlay={statusMenu(item)}>
            //             <Button>
            //                 {status || "Select"} <DownOutlined />
            //             </Button>
            //         </Dropdown>
            //     )
            // },
            {
                title: '',
                dataIndex: 'documentUrl',
                width: 60,
                render: (documentUrl, item) =>
                    <Flex center>
                        {(documentUrl || {}).uri ?
                            <TextButton margin='0 24px' onClick={(event) => { this.downloadDoc(item); event.stopPropagation(); }} text="Download" />
                            : `Note: ${(item.namedValues || []).map(item => item.value).join(", ")}`}
                        {<ImageButton src={Edit} onClick={(event) => { this.setState({ editItem: item, editCategory: item.category, editSubCategory: item.subCategory, showEditModal: true }); event.stopPropagation(); }} />}
                    </Flex>
            }
        ]
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.fetchData({ pagination: pagination });
    }

    onChangeTab = (selectedTab) => {
        this.setState({ selectedTab: selectedTab });
    }

    // Download All docs
    downloadAll = (docs) => {
        const zip = new JSZip();
        let count = 0;
        const zipFilename = "BusinessDocuments.zip";
        docs.forEach(async function (doc, index) {
            if (doc.documentUrl.uri) {
                const urlArr = doc.documentUrl.uri.split('.');
                var fileExtension = urlArr[urlArr.length - 1];
                var filename = (doc.name).includes(fileExtension) ? doc.name : doc.name + "." + fileExtension;

                try {
                    getPreSignedS3Url({ url: doc.documentUrl.uri }, async (err, preSignedUrl) => {
                        try {
                            const file = await JSZipUtils.getBinaryContent(preSignedUrl)
                            zip.file(filename, file, { binary: true });
                            count++;
                            if (count === docs.length) {
                                zip.generateAsync({ type: 'blob' }).then(function (content) {
                                    saveAs(content, zipFilename);

                                });
                            }
                        }
                        catch (err) {
                            console.log(err);
                        }
                    })
                } catch (err) {
                    console.log(err);
                }
            } else {
                count++;
            }

        });
    }

    // Download Individual Doc
    downloadDoc = (item) => {
        const urlArr = item.documentUrl.uri.split('.');
        var fileExtension = urlArr[urlArr.length - 1];
        var filename = (item.name).includes(fileExtension) ? item.name : item.name == "FinancialReport" || item.name == "ControlCenter" ? item.displayName + "." + fileExtension : item.name + "." + fileExtension;
        getPreSignedS3Url({ url: item.documentUrl.uri }, async (err, preSignedUrl) => {
            try {
                // prevents opening file in new tab
                let blob = await fetch(preSignedUrl).then((r) => r.blob());
                saveAs(blob, filename);

            } catch (err) {
                console.log(err);
            }
        })
    }

    fetchApprovedRequests = (options) => {
        const { loanApp } = this.props;
        const { pagination } = options || {};
        var body = {
            "size": pagination.pageSize,
            "page": pagination.current - 1,
            "sortDirection": "DESC"
        };
        if (loanApp) {
            body["BusinessId"] = loanApp.businessId;
            body["applicationId"] = loanApp.applicationId;
            body["uploadCategory"] = "Custom Upload"
        }

        console.log("/lsm/getApprovedLoanRequest body", body);
        this.setState({ loading: true });
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getApprovedLoanRequest`, null, body, (err, resp) => {
            console.log("/lsm/getApprovedLoanRequest resp", resp);
            this.setState({ loading: false });
            try {
                const data = resp || {};
                if (data.result) {
                    this.setState({ approvedRequests: data.requests });

                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/getApprovedLoanRequest err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    handleNote = (event, item) => {
        var { fileList } = this.state;
        const target = event.target;
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i]['id'] === item['id']) {
                fileList[i]['notes'] = target.value;
                break;
            }
        }

        this.setState({ fileList: fileList });
        event.stopPropagation();
    }

    handleDocTypeSelection = (value, item) => {
        var { fileList } = this.state;
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i]['id'] === item['id']) {
                fileList[i]['docType'] = value;
                fileList[i]['docSubType'] = null;
                break;
            }
        }

        this.setState({ fileList: fileList });
    }

    handleEditDocTypeSelection = (value, item) => {
        var { editItem } = this.state;
        // editItem.category = value;
        this.setState({ editCategory: value, editSubCategory: null });
    }

    handleDocSubTypeSelection = (value, item) => {
        var { fileList } = this.state;
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i]['id'] === item['id']) {
                fileList[i]['docSubType'] = value;
                break;
            }
        }

        this.setState({ fileList: fileList });
    }

    handleEditDocSubTypeSelection = (value, item) => {
        var { editItem } = this.state;
        // editItem.subCategory = value;
        this.setState({ editSubCategory: value });
    }

    handlePopupDeleteDoc = (uploadItem) => {
        var fileList = this.state.fileList
        var files = [];
        for (var i = 0; i < fileList.length; i++) {
            if (fileList[i].uri != uploadItem.uri) {
                files.push(fileList[i]);
            }
        }

        this.setState({ fileList: files });
    }

    handleDocSave = (item) => {
        const { loanApp } = this.props;
        const { UserInfo } = this.props.store
        if (!this.state.editCategory) {
            ErrorAlert({ description: 'Please select a valid document category!!!' });
            return;
        }
        if (!this.state.editSubCategory) {
            ErrorAlert({ description: 'Please select a valid document sub category!!!' });
            return;
        }

        item.category = this.state.editCategory;
        item.subCategory = this.state.editSubCategory;
        var body = {
            "userEmail": `${UserInfo.Email} (${UserInfo.FirstName} ${UserInfo.LastName})`,
            "businessDocument": item
        }
        console.log("handleSubmit DOC/SAVE saveAll body", body);
        this.setState({ popupLoading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/save`, { AionCurrentBiz: loanApp.businessId }, body, (err, resp) => {
            this.setState({ popupLoading: false, fileList: [] });
            try {
                const data = resp || {};
                if (data.result) {
                    message.success(`File saved successfully.`, 0.75);
                    this.fetchData({ pagination: this.state.pagination });
                    this.setState({ showEditModal: false });
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/docs/save err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again" });
            }
        });
    }

    handleDocSubmit = () => {
        const { loanApp } = this.props;
        const { fileList } = this.state;
        const { UserInfo } = this.props.store

        if (fileList.length == 0) {
            ErrorAlert({ description: 'Please upload atleast one document!!!' });
            return;
        }

        var businessDocuments = [];
        for (var i = 0; i < fileList.length; i++) {
            if (!fileList[i].docType) {
                ErrorAlert({ description: 'Please select a valid document category!!!' });
                return;
            }
            if (!fileList[i].docSubType) {
                ErrorAlert({ description: 'Please select a valid document sub category!!!' });
                return;
            }
            var businessDocument = {
                "name": "ControlCenter",
                "category": fileList[i].docType,
                "subCategory": fileList[i].docSubType,
                "documentUrl": fileList[i] || {},
                "notes": fileList[i].notes,
                "applicationId": loanApp.applicationId
            };
            businessDocuments.push(businessDocument);
        }

        var body = {
            "userEmail": `${UserInfo.Email} (${UserInfo.FirstName} ${UserInfo.LastName})`,
            "businessDocuments": businessDocuments
        }
        console.log("handleSubmit DOC/SAVE saveAll body", body);
        this.setState({ popupLoading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/saveAll`, { AionCurrentBiz: loanApp.businessId }, body, (err, resp) => {
            this.setState({ popupLoading: false, fileList: [] });
            try {
                const data = resp || {};
                if (data.result) {
                    message.success(`File saved successfully.`, 0.75);
                    this.fetchData({ pagination: this.state.pagination });
                    this.setState({ showUploadModal: false });
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                console.log("/docs/save err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again" });
            }
        });
    }

    getRowDetails = (record) => {
        return (<LightContainer fullWidth>
            <Flex style={{ width: "100%", padding: "20px", justifyContent: "space-between", alignItems: 'flex-start' }}>
                <FlexColumn style={{ width: "100%" }}>
                    <Flex start wrap gap='24px'>
                        <LabeledInput
                            label='Note'
                            key={`note`}
                            nomargin
                            type='read-only'
                            value={record.notes ? record.notes : '--'}
                        />
                    </Flex>
                </FlexColumn>
            </Flex>
        </LightContainer>
        )
    }

    render() {
        const { loanApp, theme } = this.props;
        const { selectedTab, showUploadModal, fileList, popupLoading, fileCategories, fileSubCategories, selectedRowId, showEditModal, editItem, editCategory, editSubCategory } = this.state;
        let { businessDocuments, approvedRequests } = this.state || [];
        let allDocs = [];
        var customDocs = businessDocuments.filter(doc => doc.category === "Custom Upload") || [];
        let nonCustomDocs = businessDocuments.filter(doc => doc.category != "Custom Upload") || [];
        let approvedCustomDocs = [];
        if (businessDocuments.length > 0 && approvedRequests.length > 0) {
            this.state.approvedRequests.map(request => {
                customDocs.map(doc => {
                    if (request.requestId === doc.requestId) {
                        approvedCustomDocs.push(doc);
                    }
                })
            })
            allDocs = nonCustomDocs.concat(approvedCustomDocs);
        } else if (businessDocuments.length > 0 && approvedRequests.length == 0) {
            allDocs = nonCustomDocs;
        }
        else {
            allDocs = businessDocuments;
        }
        allDocs = allDocs.filter(doc => doc.documentUrl.uri != null) || [];

        var docTypeOptions = ["Financials", "Know Your Business", "Know Your Customer", "Others"];
        const uploadProps = {
            action: `${environment.apiBaseUrl}/file/upload`,
            headers: {
                businesskey: loanApp.businessId,
                jwt: this.state.jwt
            },
            beforeUpload: (doc) => {
                this.setState({ uploading: true })
                var maxFileSize = 10240; // 10MB
                const uploadedFileSizeKiloBytes = doc.size / 1024
                if (uploadedFileSizeKiloBytes > maxFileSize) {
                    message.error(`File size is greater than 10MB`);
                    this.setState({ uploading: false });
                    return false;
                }
            },
            showUploadList: false,
            multiple: true,
            onChange: (info) => {
                var { dailyReportItem } = this.state;
                var savedFileList = this.state.fileList || [];
                var file = info.file;
                var { status, response, name } = file;
                if (status === "done") {
                    response = response || {};
                    savedFileList.push({
                        fileName: name,
                        uri: (response.UploadedUrls || response.uploadedUrls || [])[0],
                        file: this.props.includebase64 ? file : null
                    });
                    this.setState({ uploading: false })
                }

                var fileList = savedFileList.map((item, index) => ({ ...item, url: item.uri, id: index }));
                this.setState({ fileList: fileList });
            },
            accept: ".jpeg,.jpg,.png,.doc,.xls,.xlsx,.pdf,.docx,.ppt,.pptx,.txt,.zip"
        };

        return (
            <>
                <Tabs
                    defaultActiveKey="1"
                    onChange={this.onChangeTab}
                >
                    <Tabs.TabPane tab="All" key="All">
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Additional Documents" key="AdditionalDocuments">
                    </Tabs.TabPane>
                </Tabs>
                {
                    (selectedTab == 'All') && <>
                        <TableView
                            id="business-doc"
                            className="borderless-table row-pointer"
                            tableLayout='auto'
                            columns={this.getColumns()}
                            dataSource={allDocs}
                            rowKey='id'
                            titleText='Documents'
                            pagination={false}
                            ctaContent={
                                <Flex gap="8px" style={{ marginLeft: "20px" }}>
                                    <FlexColumn>
                                        <TextButton loading={this.state.uploading} text="Upload" color="#40a9ff"
                                            onClick={() => {
                                                this.setState({ showUploadModal: true, fileList: [] })
                                            }}
                                            rightIcon={<img width='24px' height='24px' src={UploadIcon} />} />
                                    </FlexColumn>
                                    <FlexColumn>
                                        <TextButton margin='0 24px' onClick={() => { this.downloadAll(allDocs) }} rightIcon={<Image src={Download} />} text="Download All" />
                                    </FlexColumn>
                                </Flex>
                            }
                            onRow={
                                (record, rowIndex) => {
                                    return {
                                        onClick: event => {
                                            if (record['id'] == selectedRowId) {
                                                this.setState({ selectedRowId: null })
                                            } else {
                                                this.setState({ selectedRowId: record['id'] })
                                                this.getRowDetails(record)
                                            }
                                        }, // click row
                                    }
                                }
                            }
                            expand={true} // ON by default
                            expandedRowKey={selectedRowId}
                            getRowDetails={(record) => this.getRowDetails(record)}
                        />
                        <Modal
                            visible={showEditModal}
                            footer={null}
                            closable={true}
                            width={600}
                            style={{ top: 10 }}
                            destroyOnClose={true}
                            onCancel={() => {
                                this.setState({
                                    showEditModal: false,
                                    editItem: null,
                                    editCategory: null, editSubCategory: null
                                })
                            }}
                        >
                            {editItem && <FlexColumn style={{ margin: '0 10px', minHeight: "35vh", justifyContent: "space-between" }}>
                                <FlexColumn style={{ justifyContent: "flex-start" }}>
                                    <Text heading>Update Document</Text>
                                    <div style={{ width: 300 }}>
                                        <Text>Category:</Text>
                                        <LabeledInput
                                            labelcolor={theme.colors.secondary3}
                                            id="docType"
                                            key="docType"
                                            type="select"
                                            placeholder="Select"
                                            className="no-left-padding"
                                            mode="single"
                                            allowClear
                                            value={editCategory && editCategory}
                                            onChange={(value) => { this.handleEditDocTypeSelection(value, editItem) }}
                                        >
                                            {fileCategories && fileCategories.map(opt => (
                                                <Option key={opt.name} value={opt.name}>
                                                    {opt.name}
                                                </Option>
                                            ))}
                                        </LabeledInput>
                                    </div>
                                    <div style={{ width: 300 }}>
                                        <Text>Sub Category:</Text>
                                        <LabeledInput
                                            labelcolor={theme.colors.secondary3}
                                            id="docSubType"
                                            key="docSubType"
                                            type="select"
                                            placeholder="Select"
                                            className="no-left-padding"
                                            mode="single"
                                            allowClear
                                            value={editSubCategory && editSubCategory}
                                            onChange={(value) => { this.handleEditDocSubTypeSelection(value, editItem) }}
                                        >
                                            {fileSubCategories && fileSubCategories.filter(x => x.value == editCategory).map(opt => (
                                                <Option key={opt.name} value={opt.name}>
                                                    {opt.name}
                                                </Option>
                                            ))}
                                        </LabeledInput>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button style={{ margin: '10px 0' }} solid loading={popupLoading} onClick={(e) => this.handleDocSave(editItem)} text="Save" />
                                        <Button type="primary" style={{ alignSelf: 'center', margin: '10px 10px' }} onClick={() => { this.setState({ showEditModal: false }) }} text="Close" />
                                    </div>
                                </FlexColumn>
                            </FlexColumn>}
                        </Modal>
                        <Modal
                            visible={showUploadModal}
                            footer={null}
                            closable={false}
                            width={1400}
                            style={{ top: 10 }}
                            destroyOnClose={true}
                        >
                            <FlexColumn style={{ margin: '0 10px', minHeight: "35vh", justifyContent: "space-between" }}>
                                <FlexColumn style={{ justifyContent: "flex-start" }}>
                                    <Text heading>Upload Document</Text>
                                    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 200 }}>
                                        <Flex style={{ justifyContent: "flex-end", marginBottom: 15 }}>
                                            <Upload
                                                {...uploadProps}
                                            >
                                                <TextButton loading={this.state.uploading} text={"Add Attachments"} color="#40a9ff" icon={<PlusOutlined style={{ fontSize: 14, width: 24, height: 24, color: "#40a9ff" }} />} />
                                            </Upload>
                                        </Flex>
                                        <LineItemsHeader>
                                            <div style={{ width: 300 }}>
                                                <Text color='#333' weight='600'>{'Name'}</Text>
                                            </div>
                                            <div style={{ width: 300 }}>
                                                <Text color='#333' weight='600'>{'Category *'}</Text>
                                            </div>
                                            <div style={{ width: 300 }}>
                                                <Text color='#333' weight='600'>{'Sub Category *'}</Text>
                                            </div>
                                            <div style={{ width: 300 }}>
                                                <Text right color='#333' weight='600'>{'Notes'}</Text>
                                            </div>
                                            <div style={{ width: 50, justifyContent: 'flex-end' }}>
                                                <Text right color='#333' weight='600'></Text>
                                            </div>
                                        </LineItemsHeader>
                                        {
                                            fileList.map((lineItem, i) => {
                                                return <LineItemRow key={i + "container"}>
                                                    <div style={{ width: 300 }}>
                                                        <LabeledInput
                                                            type='read-only'
                                                            value={lineItem.fileName}
                                                        />
                                                    </div>
                                                    <div style={{ width: 300 }}>
                                                        <LabeledInput
                                                            labelcolor={theme.colors.secondary3}
                                                            id="docType"
                                                            key="docType"
                                                            type="select"
                                                            placeholder="Select"
                                                            className="no-left-padding"
                                                            mode="single"
                                                            allowClear
                                                            value={lineItem.docType && lineItem.docType}
                                                            onChange={(value) => { this.handleDocTypeSelection(value, lineItem) }}
                                                        >
                                                            {fileCategories && fileCategories.map(opt => (
                                                                <Option key={opt.name} value={opt.name}>
                                                                    {opt.name}
                                                                </Option>
                                                            ))}
                                                        </LabeledInput>
                                                    </div>
                                                    <div style={{ width: 300 }}>
                                                        <LabeledInput
                                                            labelcolor={theme.colors.secondary3}
                                                            id="docSubType"
                                                            key="docSubType"
                                                            type="select"
                                                            placeholder="Select"
                                                            className="no-left-padding"
                                                            mode="single"
                                                            allowClear
                                                            value={lineItem.docSubType && lineItem.docSubType}
                                                            onChange={(value) => { this.handleDocSubTypeSelection(value, lineItem) }}
                                                        >
                                                            {fileSubCategories && fileSubCategories.filter(x => x.value == lineItem.docType).map(opt => (
                                                                <Option key={opt.name} value={opt.name}>
                                                                    {opt.name}
                                                                </Option>
                                                            ))}
                                                        </LabeledInput>
                                                    </div>
                                                    <div style={{ width: 300 }}>
                                                        <LabeledInput
                                                            type="text-area"
                                                            id="notes"
                                                            key="notes"
                                                            placeholder={`Add a note`}
                                                            onChange={(event) => { this.handleNote(event, lineItem) }}
                                                            value={lineItem.notes}
                                                        />
                                                    </div>
                                                    <div style={{ width: 50, justifyContent: 'flex-end' }}>
                                                        <Popconfirm
                                                            title={<>
                                                                <div>Are you sure you want to delete this file?</div>
                                                            </>}
                                                            onConfirm={(e) => {
                                                                e.stopPropagation()
                                                                this.handlePopupDeleteDoc(lineItem)
                                                            }}
                                                            okText="Confirm"
                                                            placement="left"
                                                            cancelText="Cancel"
                                                            onCancel={(e) => e.stopPropagation()}
                                                        >
                                                            <CloseOutlined style={{ color: "#40a9ff", fontSize: 14 }} />
                                                        </Popconfirm>
                                                    </div>
                                                </LineItemRow>
                                            })
                                        }
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button style={{ margin: '10px 0' }} solid loading={popupLoading} onClick={this.handleDocSubmit} text="Save" />
                                        <Button type="primary" style={{ alignSelf: 'center', margin: '10px 10px' }} onClick={() => { this.setState({ showUploadModal: false }) }} text="Close" />
                                    </div>
                                </FlexColumn>
                            </FlexColumn>
                        </Modal>
                    </>
                }
                {
                    (selectedTab == 'Active Request') && <AdditionalDocuments loanApp={loanApp} refreshInfoRequestedTag={this.props.changeInfoRequestedTag}></AdditionalDocuments>
                }
                {
                    (selectedTab == 'All Requests') && <AdditionalDocuments loanApp={loanApp} allRequests={true}></AdditionalDocuments>
                }
                {
                    (selectedTab == 'AdditionalDocuments') && <AdditionalDocs loanApp={loanApp} refreshInfoRequestedTag={this.props.changeInfoRequestedTag}></AdditionalDocs>
                }
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)));